import { createActionTypes } from 'zeal-redux-utils'

export default createActionTypes('user', ['UPDATE_FORM_VALUES', 'SET_USER'])



// WEBPACK FOOTER //
// ./client/modules/user/constants/actionTypes.js